import type { Workspace } from '@stratumn/studio-shared';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import type { WorkspaceFormValues } from '../form/form.workspace';
import { WorkspaceCard } from './WorkspaceCard';

type Props = {
  workspaces: Workspace[];
  processId: string;
  editingId: string | null;
  onToggleEdit: (id: string) => void;
  onCancelEdit: () => void;
  onUpdate: (values: WorkspaceFormValues) => void | Promise<void>;
  onRequestDelete: (workspace: Workspace) => void;
};

export const WorkspaceList = ({
  workspaces,
  processId,
  editingId,
  onToggleEdit,
  onCancelEdit,
  onUpdate,
  onRequestDelete
}: Props) => {
  const shouldReduceMotion = useReducedMotion();

  return (
    <motion.div
      className="flex flex-col gap-2"
      layout={!shouldReduceMotion}
      transition={{ duration: 0.25, ease: [0.23, 1, 0.32, 1] }}
    >
      <AnimatePresence initial={false}>
        {workspaces.map(ws => (
          <WorkspaceCard
            isEditing={editingId === ws.id}
            key={ws.id}
            onCancelEdit={onCancelEdit}
            onRequestDelete={onRequestDelete}
            onToggleEdit={() => onToggleEdit(editingId === ws.id ? '' : ws.id)}
            onUpdate={onUpdate}
            processId={processId}
            workspace={ws}
          />
        ))}
      </AnimatePresence>
    </motion.div>
  );
};
